import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ru from "date-fns/locale/ru";
import "./CustomDateTime.scss";

const CustomDateTime = ({ ...rest }) => {
    const [time, setTime] = useState(null);

    // Function to format raw input as HH:mm
    const formatTimeInput = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
        let formattedValue = "";

        if (value.length > 0) {
            formattedValue = value.slice(0, 2); // First two digits (hours)
            if (value.length > 2) {
                formattedValue += ":" + value.slice(2, 4); // Add minutes after colon
            }
        }

        e.target.value = formattedValue; // Update input value
    };

    return (
        <div className="CustomDateTime-wrapper">
            <DatePicker
                showTimeSelectOnly
                timeIntervals={60}
                timeCaption="Time"
                dateFormat="HH:mm"
                placeholderText="00:00"
                locale={ru}
                selected={time}
                onChange={(date) => setTime(date)}
                onChangeRaw={formatTimeInput} // Hook into raw input changes
                {...rest}
            />
        </div>
    );
};

export default CustomDateTime;
